import * as React from "react";
import { makeStyles } from "@material-ui/core";
import classnames from "classnames";

import { colors, greys } from "@styles/color.styles";
import { DefragRunFlowState, getDefragRunTagLabelFromMillis } from "@util/event-history.util";
import { fontFamilyHelvetica, weight } from "@styles/type.styles";

export interface NextDefragRunTagProps {
  millis: number;
}

const useStyles = makeStyles({
  container: {
    backgroundColor: colors.green.lightest,
    color: colors.green.darkest,
    width: "fit-content",
    borderRadius: 4,
    padding: "1px 6px",
    fontFamily: fontFamilyHelvetica,
    fontWeight: weight.bold,
    fontSize: ".875rem",
    lineHeight: 1.28,
    margin: 0,
  },
  fancy: {
    background: `linear-gradient(109.8deg, #5393C6 0%, #3EC4CF 49.72%, #5ABF96 100%)`,
    color: greys.white,
  },
});

export const NextDefragRunTag = ({ millis }: NextDefragRunTagProps) => {
  const classes = useStyles();
  const { label, flowState } = getDefragRunTagLabelFromMillis(millis);

  if (!label) {
    return null;
  }

  return (
    <span
      className={classnames(classes.container, {
        [classes.fancy]: flowState === DefragRunFlowState.Running,
      })}
    >
      {label}
    </span>
  );
};
